import React from "react";
import MetaTags from "react-meta-tags";

// Components
import Header from "./header/header";
import Services from "./services/services";
import Contact from "./contact/contact";

function App(){
    return (
        <div className="App">
            <MetaTags>
                <meta charSet="utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>
                <meta name="description" content="Especializados em letras caixa, fachadas, envelopamento e impressão digital. Ganhe desconto entrando em contato conosco. Atendemos em toda São Paulo."/>
                <meta name="theme-color" content="#009add"/>
                <link rel="manifest" href="/manifest.json"/>
                <link rel="shortcut icon" href="/favicon.png"/>
                <title>Artefield - Comunicação Visual</title>
            </MetaTags>

            <Header></Header>
            <Services></Services>
            <Contact></Contact>
        </div>
    );
}

export default (App);